import classNames from 'classnames'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'

import s from './Href.module.scss'

interface PropsType extends Omit<React.ButtonHTMLAttributes<HTMLLinkElement>, 'type'> {
  href: string
  /**
   * - 'hash' - ссылка будет иметь вид "#/yourpath, для якорных ссылок
   * - 'search' - для перехода на другой сайт
   * - 'pathname' - для перехода на другую страницу
   */
  linkType?: 'hash' | 'search' | 'pathname'
  type?: 'white' | 'corp' | 'text'
  target?: '_blank' | '_self'
  download?: boolean | string
  onClick?: React.MouseEventHandler<HTMLElement>
  basePath?: string
}

export const Href: FC<PropsType> = ({
  href,
  children,
  linkType = 'pathname',
  type = 'corp',
  target = '_self',
  download = false,
  className,
  style,
  onClick,
  basePath,
}) => {
  const classes = classNames(
    {
      [s.white]: type === 'white',
      [s.corp]: type === 'corp',
      [s.text]: type === 'text',
    },
    className,
  )

  return (
    <>
      {linkType === 'pathname' && (
        <Link to={href} target={target} className={classes} download={download} onClick={onClick} style={style}>
          {children}
        </Link>
      )}

      {linkType === 'hash' && (
        <HashLink
          to={`${basePath ?? ''}#${href}`}
          target={target}
          className={classes}
          download={download}
          onClick={onClick}
          style={style}
        >
          {children}
        </HashLink>
      )}

      {linkType === 'search' && (
        <a href={href} target={target} className={classes} download={download} onClick={onClick} style={style}>
          {children}
        </a>
      )}
    </>
  )
}
